import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useMutation, queryCache } from 'react-query';
import { req } from '@omega-energia/react';
import { useAuth } from '../../../../../auth/authProvider';

export const AlterarPercentualComissaoDialog = props => {
  const { show, onClose, data, refetchInvoices } = props;
  const { token } = useAuth();
  const [alert, setAlert] = useState({ show: false, msg: '' });
  const [valor, setValor] = useState({ texto: '', numero: 0, erro: '' });

  useEffect(() => {
    if (show && data?.percentualComissao) {
      setValor({
        texto: data.percentualComissao.toString(),
        numero: data.percentualComissao,
        erro: '',
      });
    }
  }, [show, data]);

  const [alterarPercentualComissao] = useMutation(
    () =>
      req.patch(
        `partner-invoice-comissioning-leads/${data?.paymentId}`,
        { comissionPercentage: valor.numero },
        { token },
      ),
    {
      onSuccess: () => {
        setAlert({ show: true, msg: 'Alterações realizadas com sucesso' });
        onClose();
        queryCache.refetchQueries('fetch-payments');
        if (refetchInvoices) {
          refetchInvoices();
        }
      },
      onError: error => {
        setAlert({ show: true, msg: error.message || 'Erro ao salvar' });
      },
    },
  );

  const handleInputChange = e => {
    const input = e.target.value;

    const cleanInput = input.replace(/[^\d.]/g, '');

    const parts = cleanInput.split('.');
    const formattedInput = parts[0] + (parts.length > 1 ? `.${parts.slice(1).join('')}` : '');

    const percentualNumerico = parseFloat(formattedInput);

    if (Number.isNaN(percentualNumerico) || formattedInput === '') {
      setValor({
        texto: formattedInput,
        numero: 0,
        erro: 'O percentual deve ser um número válido',
      });
      return;
    }

    setValor({
      texto: formattedInput,
      numero: percentualNumerico / 100,
      erro: percentualNumerico <= 0 ? 'O percentual deve ser maior que zero' : '',
    });
  };

  return (
    <>
      <Dialog open={show} onClose={onClose}>
        <DialogTitle>Editar percentual da comissão</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            variant="outlined"
            value={valor.texto}
            onChange={handleInputChange}
            error={!!valor.erro}
            helperText={valor.erro}
            placeholder={data?.percentualComissao || 0}
            InputProps={{
              endAdornment: <Typography variant="body1">%</Typography>,
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            CANCELAR
          </Button>
          <Button color="primary" onClick={alterarPercentualComissao} disabled={!!valor.erro || valor.numero <= 0}>
            SALVAR
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={alert.show}
        autoHideDuration={6000}
        message={alert.msg}
        onClose={() => setAlert({ show: false, msg: '' })}
      />
    </>
  );
};
